import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

//  Non trasformare in pure function
/* eslint-disable react/prefer-stateless-function */
class Option extends Component {
  render() {
    const {
      children,
      additionalData,
      className,
      notifica,
      isSelected,
      value,
      ...others
    } = this.props;
    const classes = cns(
      'select__option',
      {
        'select__option--selected': isSelected === true,
      },
      className,
    );
    return (
      <li
        className={classes}
        role="presentation"
        onClick={evt => notifica(evt, value, additionalData, true)}
        value={value}
        {...others}
      >
        {children}
      </li>
    );
  }
}

Option.defaultProps = {
  additionalData: null,
  className: '',
  children: null,
  isSelected: false,
  notifica: null,
  value: null,
};

Option.propTypes = {
  /** Dati aggiuntivi */
  additionalData: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** @ignore Indica se l'opzione è selezionata: prop inviata dal Select in base
   * al suo value */
  isSelected: PropTypes.bool,
  /**
   * Funzione di callback dell'onClick dell'option:
   * ```
   *  notifica(event, value, additionalData)
   * ```
   * dove:
   * * *event*: evento click
   * * *value*: valore associato all'option
   * * *additionalData*: eventuali dati aggiuntivi associati all'option
   */
  notifica: PropTypes.func,
  /** Valore bindato all'opzione */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
};

export default Option;
